import defaultFormat from 'date-fns/format'
import sv from 'date-fns/locale/sv'
import en from 'date-fns/locale/en-US'

export function format(date: Date, formatStr = 'PP') {
  return defaultFormat(date, formatStr, {
    locale: WISORY_SDK_SETTINGS.LOCALE === 'sv' ? sv : en,
  })
}